<template>
  <span>
    <span class="ms-1 checkbox-component" v-for="(option, index) in content.options" :key="index">
      <input type="checkbox"
             v-bind:id="`check_${index}`"
             v-bind:value="`${option}`"
             v-model="checkedOptions"
             @change="$emit('responseevent', {id: idx, response: checkedOptions})">
      <label v-bind:for="`check_${index}`" >{{option}}</label>
    </span>
  </span>
</template>

<script>
    export default {
        name: "CheckboxComponent",
        props:{
            content: Object,
            idx: Number,
        },
        data() {
            return{
                checkedOptions: []
            }
        }
    }
</script>

<style scoped>

</style>